import React, { useState } from "react";
import { connect } from "react-redux";
import AdminUsersTable from "../../components/AdminUsersTable";

const Administrador = ({ enviarmes, loggedstate }) => {
  
  return (
    <div>
      <AdminUsersTable />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    enviarmes: (mes) =>
      dispatch({
        type: "SET_MES",
        mes: mes
      })
  };
};

const mapStateToProps = (state) => ({
  loggedstate: state
});

export default connect(mapStateToProps, mapDispatchToProps)(Administrador);